import ErrorMessageComponent from './ErrorMessage';

const ErrorMessage = ErrorMessageComponent;

export default ErrorMessage;
